import { setViewport } from './modules/utils';
import { mq } from './modules/utils';
import { createClient } from 'microcms-js-sdk';
import MicroModal from 'micromodal';
import PerfectScrollbar from 'perfect-scrollbar';
import logoGrandVangogh02 from '../img/logo-grand-vangogh02.svg';

// microCMSからニュースの取得
window.addEventListener('resize', setViewport);
window.addEventListener('load', setViewport);

const client = createClient({
  serviceDomain: 'gogh',
  apiKey: import.meta.env.VITE_MICROCMS_API_KEY,
});

// ニュース一覧
const newsList = document.getElementById('news-list');
let allNewsItems = [];
document.addEventListener('DOMContentLoaded', () => {
  fetchNews();
});
async function fetchNews() {
  try {
    const res = await client.getList({
      endpoint: 'news',
      queries: {
        orders: '-publishedAt',
      },
    });

    // 新しい順にソート（降順）
    allNewsItems = res.contents.sort((a, b) => {
      new Date('2025-12-18T15:00:00.000Z');
      const dateA = new Date(a.date || a.publishedAt || a.createdAt);
      const dateB = new Date(b.date || b.publishedAt || b.createdAt);
      return dateB - dateA;
    });
    displayNews();

    // Perfect Scrollbarの初期化
    if (newsList) {
      new PerfectScrollbar(newsList, {
        wheelSpeed: 1,
        wheelPropagation: false,
        minScrollbarLength: 20,
        suppressScrollX: true,
      });
    }
  } catch (err) {
    console.error('ニュース取得エラー:', err);
    if (newsList) {
      newsList.innerHTML = '<li class="error-message">ニュースの取得に失敗しました</li>';
    }
  }
}

function displayNews(limit) {
  if (!newsList) return;

  newsList.innerHTML = '';
  const itemsToShow = limit ? allNewsItems.slice(0, limit) : allNewsItems;

  itemsToShow.forEach((item) => {
    const li = document.createElement('li');
    const linkUrl = `/news/?id=${item.id}`;
    const displayDate = item.date || item.publishedAt || item.createdAt;

    li.innerHTML = `
        <a href="${linkUrl}">
          <p class="news-date" datetime="${displayDate}">
            ${formatDate(displayDate)}
          </p>
          <div class="news-content">
            <p class="news-title">${escapeHtml(item.title)}</p>
          </div>
        </a>
      `;

    newsList.appendChild(li);
  });

  function formatDate(dateStr) {
    // YYYY-MM-DD形式のテキストの場合はそのまま.に置き換え
    if (dateStr && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      return dateStr.replace(/-/g, '.');
    }
    // 日時形式の場合は従来通り
    const d = new Date(dateStr);
    return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`;
  }

  // HTMLエスケープ関数
  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/[&<>'"]/g, function (tag) {
      const chars = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;',
      };
      return chars[tag] || tag;
    });
  }
}

// ニュース詳細
const newsDetail = document.getElementById('news-detail');

if (newsDetail) {
  document.addEventListener('DOMContentLoaded', () => {
    fetchNewsDetail();
  });
}

async function fetchNewsDetail() {
  const urlParams = new URLSearchParams(window.location.search);
  const newsId = urlParams.get('id');
  const draftKey = urlParams.get('draftKey');

  if (!newsId) {
    displayDetailError('ニュースIDが指定されていません');
    return;
  }

  try {
    // プレビュー用のクエリパラメータ
    const queries = draftKey ? { draftKey } : {};

    const newsItem = await client.getListDetail({
      endpoint: 'news',
      contentId: newsId,
      queries,
    });

    // プレビューモードの場合は通知を表示
    if (draftKey) {
      displayPreviewNotice();
    }

    displayNewsDetail(newsItem);
  } catch (err) {
    console.error('ニュース詳細取得エラー:', err);
    displayDetailError('ニュースの取得に失敗しました');
  }
}

function displayNewsDetail(item) {
  if (!newsDetail) return;

  const displayDate = item.date || item.publishedAt || item.createdAt;
  newsDetail.innerHTML = `
    <article class="news-detail-article">
      <div class="news-detail-header">
        <p class="news-date" datetime="${displayDate}">${formatDate(displayDate)}
        </p>
        <h1 class="news-detail-title">${escapeHtml(item.title)}</h1>
      </div>
      <div class="news-detail-content">
        ${item.content || ''}
      </div>
    </article>
  `;

  // target="_blank"のリンクにrel属性を追加
  processExternalLinks();
}

function processExternalLinks() {
  if (!newsDetail) return;

  // target="_blank"を持つリンクにrel属性を追加
  const targetBlankLinks = newsDetail.querySelectorAll('a[target="_blank"]');
  targetBlankLinks.forEach((link) => {
    const currentRel = link.getAttribute('rel') || '';
    if (!currentRel.includes('noopener')) {
      link.setAttribute(
        'rel',
        currentRel ? `${currentRel} noopener noreferrer` : 'noopener noreferrer',
      );
    }
  });
}

function displayDetailError(message) {
  if (!newsDetail) return;
  newsDetail.innerHTML = `<div class="error-message">${escapeHtml(message)}</div>`;
}

function displayPreviewNotice() {
  // プレビュー通知バナーを表示
  const existingNotice = document.querySelector('.preview-notice');
  if (existingNotice) return; // 既に表示されている場合は何もしない

  const notice = document.createElement('div');
  notice.className = 'preview-notice';
  notice.innerHTML = `
    <p>プレビューモード - この内容は下書きです</p>
  `;
  document.body.insertBefore(notice, document.body.firstChild);
}

// ユーティリティ関数
function formatDate(dateString) {
  return dateString?.slice(0, 10).replace(/-/g, '.') || '';
}

function escapeHtml(text) {
  if (!text) return '';
  return String(text).replace(/[&<>'"]/g, function (tag) {
    const chars = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;',
    };
    return chars[tag] || tag;
  });
}

// Micromodal.js
const microModalOptions = {
  disableScroll: true,
  disableFocus: false,
  awaitOpenAnimation: true,
  awaitCloseAnimation: true,
  debugMode: true,
};

const topNewsModalDelayMs = 1000;

// function showTopNewsModal() {
//   // トップページのポップアップ用
//   const modalId = 'modal-popup';
//   const modalElement = document.getElementById(modalId);

//   if (!modalElement) return;

//   MicroModal.show(modalId, microModalOptions);
// }

// Micromodal.jsの初期化
if (document.querySelector('.micromodal-slide')) {
  MicroModal.init(microModalOptions);
}

// オープニングアニメーション
function openingAnimation() {
  const isTopPage =
    window.location.pathname === '/' ||
    window.location.pathname === '/index.html' ||
    window.location.pathname.endsWith('/src/');
  if (!isTopPage) return;

  const openVisual = document.querySelector('.opening-visual');
  const mainVisual = document.querySelector('.main-visual');
  const mainVisualTitle = document.querySelector('.main-visual-title');
  const catchCopy = document.querySelector('.main-visual .catch-copy');
  const catchCopyOpening = document.querySelector('.catch-copy-opening');

  if (!openVisual || !mainVisual || !mainVisualTitle) return;

  const hasVisited = sessionStorage.getItem('hasVisitedTop');

  // 2回目以降はアニメーションスキップ
  if (hasVisited) {
    openVisual.classList.add('is-none');
    mainVisual.classList.add('is-active');
    mainVisualTitle.classList.add('is-active');
    if (catchCopy) catchCopy.classList.add('is-active');
    return;
  }

  document.body.classList.add('no-scroll');

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      // ブラー開始
      if (catchCopyOpening) {
        catchCopyOpening.classList.add('is-blur-active');
      }

      // オープニングを消す
      setTimeout(() => {
        openVisual.classList.add('is-hidden');

        // 背景表示
        setTimeout(() => {
          mainVisual.classList.add('is-active');
        }, 300);

        // タイトル表示
        setTimeout(() => {
          document.body.classList.remove('no-scroll');
          mainVisualTitle.classList.add('is-active');

          // キャッチコピー表示
          const catchCopyDelay = mq('sp') ? 200 : 900;
          setTimeout(() => {
            if (catchCopy) {
              catchCopy.classList.add('is-active');
            }
            sessionStorage.setItem('hasVisitedTop', 'true');
          }, catchCopyDelay);
        }, 1000);
      }, 1100); // ブラーを見せる時間
    });
  });
}

// スムーススクロール
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');

      // href="#"のみの場合はスキップ
      if (href === '#') return;

      const targetElement = document.querySelector(href);
      if (targetElement) {
        e.preventDefault();
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });
  });
});

// メインビジュアルの背景とロゴをランダムで変更
function mainVisualRandomBg() {
  const mainVisualTitle = document.querySelector('.main-visual-title');
  const logoRandomImg = document.querySelector('.logo-random img');

  if (!mainVisualTitle || !logoRandomImg) return;

  if (mainVisualTitle && logoRandomImg && Math.random() < 0.5) {
    mainVisualTitle.classList.add('bg-gradation');
    logoRandomImg.src = logoGrandVangogh02;
    logoRandomImg.classList.remove('logo-bg-base');
  } else {
    logoRandomImg.classList.add('logo-bg-base');
  }
}

// ハンバーガーメニュー
function humMenu() {
  const headerMenu = document.getElementById('header');
  const menuBtn = document.getElementById('menuBtn');
  const menuBg = document.getElementById('menuBg');
  const menuText = document.getElementById('menuToggleText');

  const naviMenu = document.querySelectorAll('.menu-list li a');

  Array.from(naviMenu).forEach((e) => {
    e.addEventListener('click', () => {
      headerMenu.classList.remove('is-open');
    });
  });

  menuBtn.addEventListener('click', () => {
    headerMenu.classList.toggle('is-open');
    if (headerMenu.classList.contains('is-open')) {
      menuText.textContent = 'CLOSE';
    } else {
      menuText.textContent = 'MENU';
    }
  });

  if (mq('pc')) {
    menuBg.addEventListener('click', () => {
      headerMenu.classList.remove('is-open');
    });
  }
}

// TOPページでメインビジュアル通過後にメニューを表示
function showMenuFunc() {
  const isTopPage =
    window.location.pathname === '/' ||
    window.location.pathname === '/index.html' ||
    window.location.pathname.endsWith('/src/');

  if (!isTopPage) return;

  const menuToggle = document.querySelector('.menu-toggle-container');
  const btnTicket = document.querySelector('.btn-ticket-container');
  const mainVisual = document.querySelector('.main-visual-container');

  if (!menuToggle || !mainVisual) return;

  // 初期状態は非表示
  menuToggle.style.opacity = '0';
  menuToggle.style.pointerEvents = 'none';
  if (btnTicket) {
    btnTicket.style.opacity = '0';
    btnTicket.style.pointerEvents = 'none';
  }

  function scrollAction() {
    const mainVisualBottom = mainVisual.offsetTop + mainVisual.offsetHeight;
    const scrollPosition = window.scrollY;

    if (scrollPosition > mainVisualBottom) {
      menuToggle.style.opacity = '1';
      menuToggle.style.pointerEvents = 'auto';
      if (btnTicket) {
        btnTicket.style.opacity = '1';
        btnTicket.style.pointerEvents = 'auto';
      }
    } else {
      menuToggle.style.opacity = '0';
      menuToggle.style.pointerEvents = 'none';
      if (btnTicket) {
        btnTicket.style.opacity = '0';
        btnTicket.style.pointerEvents = 'none';
      }
    }
  }

  window.addEventListener('scroll', scrollAction);
  scrollAction(); // 初期表示時にもチェック
}

// アコーディオン
function accordion() {
  const accordionTitles = document.querySelectorAll('.accordion-title');

  if (!accordionTitles.length) return;

  accordionTitles.forEach((accordionTitle) => {
    accordionTitle.addEventListener('click', (e) => {
      const tag = e.currentTarget;
      const content = tag.nextElementSibling;

      if (!content) return;

      if (tag.classList.contains('show-accordion')) {
        tag.classList.remove('show-accordion');
        content.style.maxHeight = '0';
        content.style.paddingBottom = '0';
      } else {
        tag.classList.add('show-accordion');
        content.style.maxHeight = content.scrollHeight + 40 + 'px';
        content.style.paddingBottom = '3rem';
      }
    });
  });
}

// Intersection Observer
function IntersectionObserverFunc() {
  const options = {
    root: null,
    rootMargin: '-20%',
    threshold: 0,
  };

  const doWhenIntersect = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-active');
      }
    });
  };

  const observer = new IntersectionObserver(doWhenIntersect, options);
  const targets = document.querySelectorAll('.fadeIn');
  targets.forEach((target) => {
    observer.observe(target);
  });
}

window.addEventListener('DOMContentLoaded', () => {
  openingAnimation();
  humMenu();
  showMenuFunc();
  accordion();
  mainVisualRandomBg();
  IntersectionObserverFunc();
});
